import * as XLSX from "xlsx";
import { Redemption } from "../../../api/redemption/Redemption";

const PREFERRED_HEADERS = [
  "OrderId",
  "SimIdx",
  "CreatedAt",
  "UpdatedAt",
  "Email",
  "Status",
  "InternalSku",
  "IsSent",
  "AssignedSimId",
];

const TEXT_HEADERS = new Set([
  "OrderId",
  "AssignedSimId",
  "AssignedSimConfCode",
  "snCode",
  "snPin",
]);

function exportValue(value: unknown): string | number | boolean {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value;
  }
  return String(value);
}

export function createRedemptionsWorkbook(redemptions: Redemption[]) {
  const discoveredHeaders = Array.from(
    new Set(redemptions.flatMap((redemption) => Object.keys(redemption))),
  );
  const headers = [
    ...PREFERRED_HEADERS.filter((header) => discoveredHeaders.includes(header)),
    ...discoveredHeaders.filter((header) => !PREFERRED_HEADERS.includes(header)),
  ];
  const rows = redemptions.map((redemption) => Object.fromEntries(
    headers.map((header) => [
      header,
      exportValue(redemption[header as keyof Redemption]),
    ]),
  ));

  const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
  for (const header of TEXT_HEADERS) {
    const column = headers.indexOf(header);
    if (column < 0) continue;

    redemptions.forEach((redemption, index) => {
      const value = redemption[header as keyof Redemption];
      if (typeof value !== "string") return;

      const address = XLSX.utils.encode_cell({ r: index + 1, c: column });
      const cell = worksheet[address];
      if (cell) {
        cell.t = "s";
        cell.v = value;
        cell.z = "@";
      }
    });
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
  return workbook;
}

export function redemptionsFilename(date = new Date()) {
  return `redemption-orders-export-${date.toISOString().split("T")[0]}.xlsx`;
}
